module.exports = __webpack_public_path__ + "img/single-neutral-actions-add.1349b895.svg";